import React from 'react'
import { Grid, Typography } from '@mui/material'
import Loading from 'Components/Loading'
import { useHistory } from 'Components/useHistory'
import { usePatient } from 'Components/usePatientContext'
import { useFormikContext } from 'formik'
import InputCpf from 'Components/InputCpf'

export default function Form() {

    const { 
        get, 
        userExists, 
        loading 
    } = usePatient()
    
    const { 
        touched,
        errors,
        isValid,
        values, 
        handleChange, 
        handleBlur 
    } = useFormikContext()

    const { historyPaths } = useHistory()

    historyPaths.add('/')

    React.useEffect( () => { 
        
        const cpf = values.cpfPaciente?.replace(/[^0-9]/g,'')
        
        if (cpf?.length === 11 && isValid) { 
            get({cpfPaciente: values.cpfPaciente })
        }

    }, [ get, isValid, values.cpfPaciente ])

    return (
        <>
            <Grid item md={12} xs={12} py={2} >
                <InputCpf
                    
                    id="cpfPaciente"
                    name="cpfPaciente"
                    
                    disabled={loading}
                    onChange={handleChange}
                    value={values.cpfPaciente} 
                    onBlur={handleBlur}
                    
                    label="CPF"
                    required={true}
                    placeholder="Digite o seu CPF"
                    fullWidth
                    error={touched.cpfPaciente && Boolean(errors.cpfPaciente)}
                    
                    helperText={
                        values?.cpfPaciente?.length === 0 ? 
                        <Typography variant='subtitle1' component='span'>Digite seu CPF para iniciarmos o agendamento</Typography> 
                        : touched.cpfPaciente && errors.cpfPaciente
                    }
                    
                />
                   
               
            </Grid>  
            {loading && !userExists && <Loading />}  
        </>  
    )
}